import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';

import './Header.css';

class Header extends React.Component {
  render() {
    return (
      <Row id="Header">
        <Col md={6}>
          <h1>Pagamento da taxa de alteração</h1>
          <h2>Informações do cartão</h2>
        </Col>
        <Col md={6}>
          <Button bsClass="back-button">Voltar</Button>
        </Col>
      </Row>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/page/paymentChange/components/Header/index.jsx